module.exports = __webpack_public_path__ + "media/src/images/logos/dailytics-63b2cd7f0d6aa24c65389144b1b20e47.png";